import { render, staticRenderFns } from "./SubmissionsGridViewItem.vue?vue&type=template&id=868f59d2&scoped=true"
import script from "./SubmissionsGridViewItem.vue?vue&type=script&lang=js"
export * from "./SubmissionsGridViewItem.vue?vue&type=script&lang=js"
import style0 from "./SubmissionsGridViewItem.vue?vue&type=style&index=0&id=868f59d2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868f59d2",
  null
  
)

export default component.exports